import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, NgZone } from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import { Router } from "@angular/router";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { InvoiceModel } from "../models/invoice.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";

const moment = require("moment");

@Component({
  selector: 'directdebit-collection-date-popup',
  template: require('../views/directdebit-collection-date-popup.component.html'),
})

export class DirectdebitCollectionDatePopupComponent implements OnInit {
  apiErrorMsg: any;
  _model: InvoiceModel[];

  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;
  public collectionDate: string = "";
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;

  @ViewChild('collectionDateModel') public collectionDateModel: any;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private zone: NgZone) {

  }

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
  }
  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }
  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    this.collectionDateModel.show();
  }

  public hide(): void {
    this.collectionDateModel.hide();
  }
  public OnExport(event: any) {

  }
  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg })
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/directdebit-collection-date-popup.component.ts